import { AbstractControl, UntypedFormArray, UntypedFormGroup } from "@angular/forms";

/**
 * Mark the control and all the subcontrols as touched. This functionality is actually implemented in `Angular 8`.
 *
 * @param control - Control to be marked as touched.
 */
export const markAllAsTouched = (control?: AbstractControl): void => {
	if (!control) {
		return;
	}

	control.markAsTouched({ onlySelf: true });

	if (control instanceof UntypedFormArray) {
		control.controls.forEach((c: AbstractControl) => markAllAsTouched(c));
	} else if (control instanceof UntypedFormGroup) {
		Object.keys(control.controls).forEach((k) => markAllAsTouched(control.controls[k]));
	}
};
